<template>
  <!--$t('global.菜单分类')-->
  <div class="homeTags nav clearfix">
    <div class="iconBox clearfix">
      <router-link to="/hotList/weekList" class="list" target="_blank">
        <img
          class="listImg"
          src="/static/home/index_icon_trendlist@2x.png"
          alt=""
        />
        <p class="title">{{ $t("live.榜单") }}</p>
      </router-link>
      <router-link to="/jobs/home" class="live" target="_blank">
        <img class="liveImg" src="https://image.manamana.net/1668397953000_CHHXXBID" alt="" />
        <p class="title">{{ $t("global.招聘") }}</p>
      </router-link>
      <div class="line"></div>
    </div>
    <div
      class="leftnav"
      v-for="item in cate"
      :key="item.name"
      v-if="item.id != 15"
    >
      <div class="left">
        <span class="title">{{
          language === "zh" ? item.name : item.enName
        }}</span>
        <router-link class="all" target="_blank" to="/explorevideo"
          >{{ $t("global.全部") }}<i></i
        ></router-link>
      </div>
      <div class="right" :class="{enRight:language !== 'zh'}">
        <span
          class="tagList"
          v-for="subitem in item.tagEditFroms"
          @click="selectCate(item, subitem)"
          :key="subitem.name"
          >{{ language === "zh" ? subitem.name : subitem.enName }}</span
        >
      </div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterTableHome",
  // model: {
  //   prop: "selectedfilters",
  // },
  data() {
    return {
      allitemList: {},
    };
  },
  // props: {
  //   selectedfilters: Array, //$t('global.选中列表')
  //   cate: Array, //$t('global.类别列表')
  //   singleselect: Boolean, //$t('global.是否单选')
  //   showall: Boolean, //$t('global.是否显示全部')
  // },
  props: {
    cate: Array,
  },
  methods: {
    selectCate(index, item) {
      // if(!this.singleselect){
      //   if(this.selectedfilters.indexOf(item)>-1){
      //     this.selectedfilters.splice(this.selectedfilters.indexOf(item),1);
      //   }else{
      //     this.selectedfilters.push(item);
      //   }
      // }else{
      //   if(this.selectedfilters.indexOf(item)==-1){
      //     var changed=false;
      //     for (var i =0;i<this.selectedfilters.length;i++){
      //       if(this.selectedfilters[i].cat==item.cat){
      //         this.selectedfilters[i]=item;
      //         changed=true;
      //         break;
      //       }
      //     }
      //     if(!changed){
      //       this.selectedfilters.push(item);
      //     }
      //   }else{
      //     this.selectedfilters.splice(this.selectedfilters.indexOf(item),1);
      //   }
      // }
      // this.$forceUpdate();
      // this.$emit('select-changed')
      let routeData = this.$router.resolve({
        path: "/explorevideo",
        query: { topGroupId: index.id, groupId: item.id },
      });
      window.open(routeData.href, "_blank");
    },
    // sortCate(data) {
    //   if (data&&data.length) {
    //     return data.slice().sort((a,b) => a.id - b.id)
    //   }
    //   return data
    // }
  },
  created() {
    if (this.showall) {
      this.allitemList = {};
      for (var i = 0; i < this.cate.length; i++) {
        this.allitemList[this.cate[i].name] = {
          name: this.$t("global.全部"),
          value: "",
          cat: this.cate[i].list[0].cat,
        };
      }
    }
  },
  computed: {
    language() {
      return this.$language();
    },
  },
};
</script>

<style lang="stylus" scoped>
.homeTags {
  width: 1110px;
  height: 80px;
  margin: 0 auto;
  background: #fafafa;
  color: #333;

  .iconBox {
    float: left;
    width: 158px;
    position: relative;
    padding-top: 3px;
    box-sizing: border-box;

    .list {
      position: relative;
      float: left;
      margin: 0 12px 0 16px;

      .listImg {
        width: 56px;
        height: 56px;
      }

      .title {
        position: absolute;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        text-align: center;
        bottom: -14px;
        left: 50%;
        transform: translate(-50%);
        height: 21px;
        line-height: 21px;
      }

      &:hover {
        .title {
          color: #FC6240;
        }
      }
    }

    .live {
      position: relative;
      float: left;

      .liveImg {
        width: 56px;
        height: 56px;
      }

      .title {
        position: absolute;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        text-align: center;
        bottom: -14px;
        left: 50%;
        transform: translate(-50%);
        height: 21px;
        line-height: 21px;
      }

      &:hover {
        .title {
          color: #3664ED;
        }
      }
    }

    .line {
      position: absolute;
      width: 1px;
      height: 37px;
      background: rgba(224, 224, 224, 1);
      right: 0;
      top: 21px;
    }
  }

  .leftnav {
    float: left;
    width: 317px;
    padding-left: 20px;
    box-sizing: border-box;
    position: relative;

    &:last-child {
      margin-right: 0;
    }

    .left {
      font-size: 15px;
      font-weight: 500;
      color: #333333;
      float: left;
      margin-right: 20px;
      // width: 80px;
      text-align: right;

      .title {
        margin-top: 15px;
        margin-bottom: 6px;
        line-height: 24px;
        display: block;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        margin-right: 4px;
      }

      .all {
        display: block;
        font-size: 12px;
        font-weight: 400;
        color: #999999;

        &:hover {
          color: #333;
        }

        i {
          width: 9px;
          height: 13px;
          display: inline-block;
          background: url('/static/home/tags_go_arrow@2x.png') no-repeat;
          background-size: 100% 100%;
          margin-left: 2px;
          vertical-align: middle;
          margin-bottom: 2px;
        }
      }
    }

    .right {
      font-size: 13px;
      font-weight: 400;
      color: #666666;
      float: left;
      width: 238px;
      // line-height: 24px;
      height: 48px;
      margin-top: 16px;
      overflow: hidden;
      word-break: break-word;
      position: relative;

      span.tagList {
        font-size: 13px;
        font-weight: 400;
        color: #333;
        margin-right: 20px;
        cursor: pointer;
        display: inline-block;
        margin-bottom: 11px;

        &:hover {
          color: #2026cc;
        }
      }
    }
    .enRight {
      width: 193px;
    }
    .line {
      position: absolute;
      width: 1px;
      height: 37px;
      background: rgba(224, 224, 224, 1);
      right: 0;
      top: 21px;
    }

    &:last-child .line {
      display: none;
    }

    &:nth-child(4) {
      .right {
        width: 204px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/FilterTableHome.vue